/**
 * Multi-field Pro のデフォルトオプション
 */
export const defaultOptions = {
    debug: false,
    addType: '',
    showAddContainer: false,
    showAddFieldButton: true,
    showViewRawDataButton: false,
    showSortButton: true,
    showInsertButton: true,
    showRemoveButton: true,
    addFieldButtonLabel: 'フィールドを追加',
    insertPoint: -1,
    insertPointDirection: 0,
    items: [],
    // version: 3,
    minBlocks: 0,
    maxBlocks: 0,
    maxBlocksType: '',
    maxBlocksMessage: {
        type: 'warning',
        title: 'フィールドブロック数が上限に達しました',
        content: '<p class="mb-0"><strong>最大ブロック数は %maxblocks です。</strong></p>'
    },
    updated: 0,
    /**
     * {
     *   type: 'fieldType', // フィールドのタイプ（一意）
     *   label: 'フィールドラベル', // フィールドのラベル
     *   yourFieldHandle: '初期値'
     * }
     */
    fieldGroups: [
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
        ['text', 'email', 'url', 'tel', 'password', 'number', 'date', 'time', 'textarea', 'code', 'tinymce'],
        ['select', 'checkbox', 'radio'],
        ['asset', 'image', 'contentData'],
        ['table', 'tableVerticalFixed'],
        ['multiColumn'],
        ['nickname', 'lastName', 'firstName']
    ]
};
